import { featuredArticle } from '@/mocks/articles';

export default function FeaturedArticle() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-0">
          {/* Left: text */}
          <div className="w-full lg:w-[40%] flex flex-col items-start">
            <span className="inline-block px-3 py-1 rounded-full border border-accent-200 text-xs font-medium text-accent-600 tracking-wide mb-6">
              Latest SEO Guide
            </span>

            <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-900 leading-none mb-1">
              What Is
            </h2>
            <h2 className="text-4xl md:text-5xl font-heading font-light text-secondary-400 leading-none mb-10">
              Litbuy Spreadsheet?
            </h2>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-md mb-8">
              {featuredArticle.excerpt}
            </p>

            <a
              href={`/article/${featuredArticle.slug}`}
              className="inline-flex items-center gap-2 text-foreground-800 font-medium text-sm border-b border-foreground-300 hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 pb-1 cursor-pointer whitespace-nowrap"
            >
              Read Full Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>

          {/* Right: image cards */}
          <div className="w-full lg:w-[60%] relative h-[320px] md:h-[400px]">
            {/* Small square card */}
            <div className="absolute left-[8%] top-[5%] w-[140px] h-[140px] md:w-[170px] md:h-[170px] rounded-2xl overflow-hidden z-10" style={{boxShadow: '0 4px 25px rgba(0,0,0,0.05)'}}>
              <img
                src="https://readdy.ai/api/search-image?query=A%20laptop%20screen%20displaying%20a%20clean%20organized%20spreadsheet%20interface%20with%20product%20data%20columns%20and%20color-coded%20rows%20on%20a%20warm%20wooden%20desk%20with%20a%20ceramic%20coffee%20mug%20beside%20it%20soft%20morning%20light%20from%20a%20nearby%20window%20modern%20cozy%20home%20office%20setup%20editorial%20work-from-home%20photography&width=400&height=400&seq=featured-sm-v3-d7k4&orientation=squarish"
                alt="Litbuy Spreadsheet interface guide"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            {/* Large vertical card */}
            <div className="absolute right-[10%] bottom-[5%] w-[180px] h-[250px] md:w-[220px] md:h-[300px] rounded-2xl overflow-hidden z-20" style={{boxShadow: '0 4px 25px rgba(0,0,0,0.05)'}}>
              <img
                src="https://readdy.ai/api/search-image?query=An%20open%20notebook%20with%20handwritten%20spreadsheet%20notes%20and%20product%20catalog%20sketches%20surrounded%20by%20a%20pen%20calculator%20and%20a%20small%20potted%20plant%20on%20a%20clean%20desk%20warm%20natural%20daylight%20from%20large%20window%20minimalist%20organizational%20productivity%20photography%20with%20soft%20creamy%20color%20palette&width=500&height=700&seq=featured-lg-v3-e8m6&orientation=portrait"
                alt="Litbuy Spreadsheet comprehensive guide"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}